/**
 * Text component types
 * @name TextComponentType
 */
export var TextComponentType;
(function (TextComponentType) {
    TextComponentType["BOLD"] = "b";
    TextComponentType["ANCHOR"] = "a";
    TextComponentType["STRONG"] = "strong";
    TextComponentType["ITALIC"] = "i";
    TextComponentType["EMPHASIZED"] = "em";
    TextComponentType["MARK"] = "mark";
    TextComponentType["SMALL"] = "small";
    TextComponentType["DELETED"] = "del";
    TextComponentType["INSERTED"] = "ins";
    TextComponentType["SUBSCRIPT"] = "sub";
    TextComponentType["SUPERSCRIPT"] = "sup";
    TextComponentType["PARAGRAPH"] = "p";
    TextComponentType["SPAN"] = "span";
    TextComponentType["LABEL"] = "label";
    TextComponentType["LEGEND"] = "legend";
    TextComponentType["H1"] = "h1";
    TextComponentType["H2"] = "h2";
    TextComponentType["H3"] = "h3";
    TextComponentType["H4"] = "h4";
    TextComponentType["H5"] = "h5";
    TextComponentType["H6"] = "h6";
    TextComponentType["DL"] = "dl";
    TextComponentType["DT"] = "dt";
    TextComponentType["DD"] = "dd";
    TextComponentType["DIV"] = "div";
})(TextComponentType || (TextComponentType = {}));
//# sourceMappingURL=component.js.map